import {MessageDescriptor} from '@lingui/core';
import {t} from '@lingui/macro';

export enum FileExtensionParameterErrorsEnum {
  DUPLICATE_TOKEN = 'DUPLICATE_TOKEN',
  INCORRECT_FORMAT = 'INCORRECT_FORMAT',
  TOKEN_LENGTH = 'TOKEN_LENGTH',
  TOKENS_COUNT = 'TOKENS_COUNT',
}

/*
 * Labels.
 */

export const fileExtensionParameterErrorMessages: Record<
  FileExtensionParameterErrorsEnum,
  MessageDescriptor
> = {
  [FileExtensionParameterErrorsEnum.DUPLICATE_TOKEN]: t(
    'file-extension-error-token-duplicate',
  )`Extension is already present`,
  [FileExtensionParameterErrorsEnum.INCORRECT_FORMAT]: t(
    'file-extension-error-token-format',
  )`Extension must be alphanumerical characters, separated by a dot`,
  [FileExtensionParameterErrorsEnum.TOKEN_LENGTH]: t(
    'file-extension-error-token-length',
  )`Extensions limited to 10 characters`,
  [FileExtensionParameterErrorsEnum.TOKENS_COUNT]: t(
    'file-extension-error-tokens-count',
  )`15 extensions maximum`,
};
